import React from 'react';
import ReactDOM from 'react-dom';
import { AfterRefactorApp, BeforeRefactorApp } from './App';

ReactDOM.render(
  <React.StrictMode>
    <BeforeRefactorApp />
  </React.StrictMode>,
  document.querySelector('#root-before-refactor')
);

ReactDOM.render(
  <React.StrictMode>
    <AfterRefactorApp />
  </React.StrictMode>,
  document.querySelector('#root-after-refactor')
);
